import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editCity = ( {data, cityId} : {data: IPostEditCity | {}, cityId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/Cities/UpdateCity/${cityId}`, data);
};

type QueryFnType = typeof editCity;

type UseEditCityOptions = {
  data: IPostEditCity | {};
  cityId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditCity = ({ config }: UseEditCityOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Πόλης.`, 500);
            console.error('Couldnt edit City', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllCities"])
            addNotification('Η Πόλη Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editCity,
    })
}